import { Widget, WIDGET_CALL_TO_ACTION } from "@gaming/srvg-classes-core";


export class CallToActionWidget extends Widget {
    widgetName: string;
    widget: any;

    constructor( options ) {
        options = options || {};
        options.selector = options.selector || '#callToActionWidget';
        super( options );

        this.name = 'widgetcalltoaction';
        this.widgetName = options.widgetName || WIDGET_CALL_TO_ACTION;
        this.widgetName = this.product + this.widgetName;

        this.widget = null;
        this.widgetOptions = {
            height: this.getContainerHeightWithUnit()
        };
        this.mergeWidgetOptions(options);
    }

    handleDomInstantiated() {
        this.addCallToActionWidget();
        super.handleDomInstantiated();
    }

    /**
     * add matchday selector widget to given selector (html element selector)
     * @param string selector html element selected (not element itself)
     */
    addCallToActionWidget(selector?) {
        var that = this;
        selector = selector || this.selector;

        this.widget = this.addWidget(
            selector,
            this.widgetName,
            this.widgetOptions
        );
    }

}
